import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TabViewModule } from 'primeng/primeng';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-employee-virtual-office',
  templateUrl: './employee-virtual-office.component.html',
  styleUrls: ['./employee-virtual-office.component.scss']
})
export class EmployeeVirtualOfficeComponent implements OnInit {
  public employeePositionId: number;
  public url: SafeResourceUrl = null;

  constructor(
    public translate: TranslateService,
    public TabViewModule: TabViewModule,
    private sanitizer: DomSanitizer,
  ) {
    this.employeePositionId= this.getEmployeePositionId();

    this.url = this.sanitizer.bypassSecurityTrustResourceUrl('https://sorttime.co/sorttime2/oficina/RHS/inicio.aspx');
  }

  ngOnInit() {
  }

  public hasRole(rol) {
    var r: boolean = false;
    var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
    if (role == rol) {
      r = true;
    }
    return (r);
  }

  public getEmployeePositionId() {
    var employeePosition = JSON.parse(localStorage.getItem('profile')).employee.employee_position_id;
    return (employeePosition);
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/employee-virtual-office/employee-virtual-office.component.ts